import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';

const useStyles = makeStyles((theme) => ({
  root: {
      lineHeight: ".75rem" 
  },
  inputCtC : {
    backgroundColor: "transparent !important",
    fontSize: "0.75rem",
    borderBottom: "1px solid #000",
    padding: 0,
    height: "0.875rem !important",
    width: "70px"
}
}));

function InputClickToCall(props) {
  const classes = useStyles();

  return (
    <InputBase
    type={"text"}
    id="input-click-to-call"
    classes={{root: classes.root, input: classes.inputCtC}}
    value={props.value}
    onChange={(e)=>props.onChange(e.target.value)}
    inputProps={{ 'aria-label': 'naked', maxLength: 9}}
  />
    )
}


      export {InputClickToCall}